export const sortByAbsoluteValue = (order) => (a, b) => {
    const val1 = Math.abs(a.data)
    const val2 = Math.abs(b.data)
  
    if (val1 > val2) return order === 'asc' ? 1 : -1
    if (val1 < val2) return order === 'asc' ? -1 : 1
    return 0
}